import { render, staticRenderFns } from "./OnboardingDocumentsTab.vue?vue&type=template&id=3e7da736&"
import script from "./OnboardingDocumentsTab.vue?vue&type=script&lang=js&"
export * from "./OnboardingDocumentsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports